import { addDays, differenceInMilliseconds, intervalToDuration } from 'date-fns';

import { SleepDiary, SleepSession } from '../api/hooks/sleep';

import DateUtils from './DateUtils';

export enum ResultIndex {
  /** 전체 수면 시간*/
  TST = 0,
  /** 침대에서 보낸 시간*/
  TIB = 1,
  /** 수면 효율성*/
  SE = 2,
  /** 수면 지연*/
  SOL = 3,
  /** 중간에 깬 횟수*/
  WASC = 4,
  /** 중간에 깬 시간*/
  WASO = 5,
  /** 중간에 깬 시간 중 잠자리 밖에서 보낸 시간*/
  TOB = 6,
  /**  전날 낮잠 횟수*/
  NF = 7,
  /** 약물 복용 여부*/
  MU = 8,
  /** 수면 만족도*/
  SS = 9,
  /**수면 문제로 인한 지장*/
  SD = 10,
  /** 일어나려고 했던 시각*/
  IWT = 11,
  /**잠자리에 누운 시각 */
  BT = 12,
  /**자려고 눈 감은 시각 */
  AST = 13,
  /** 마지막으로 잠이 깬 시각*/
  FWT = 14,
  /**마지막으로 잠자리에서 나온 시각 */
  OBT = 15,
}

const SleepUtils = {
  dateFormat: (session: SleepSession) => {
    const start = DateUtils.toKoreanDateTime(session.startDate);
    const end = DateUtils.toKoreanDateTime(session.endDate);
    if (SleepUtils.isDone(session)) {
      return `${start} 시작 /
          ${end} 종료`;
    } else {
      return `${start} 시작 /
                  ${end} 종료 예정`;
    }
  },
  // 마지막 회차 일기는 종료일 다음날에 작성할 수 있어(answeredOnNextDay) 종료일 하루 뒤부터 종료로 본다.
  isDone: (session: SleepSession) => {
    return differenceInMilliseconds(new Date(), addDays(new Date(session.endDate), 1)) >= 0;
  },
  isReady: (session: SleepSession) => {
    return differenceInMilliseconds(new Date(), new Date(session.startDate)) < 0;
  },
  isInprogress: (session: SleepSession) => {
    return !SleepUtils.isDone(session) && !SleepUtils.isReady(session);
  },
  isCanceled: (session: SleepSession) => {
    return !!session.canceledAt;
  },
  totalValue: (diaries: SleepDiary[] = [], index: ResultIndex) => {
    return diaries.reduce((acc, curr) => acc + (curr.answerSheets[0]?.results?.[index].score || 0), 0);
  },

  formatTime: (minutes?: number, useHourFormat: boolean = true) => {
    if (minutes === undefined || isNaN(minutes)) {
      return '';
    }

    const duration = intervalToDuration({ start: 0, end: minutes * 60 * 1000 });
    const hours = duration.hours || 0;
    const mins = duration.minutes || 0;

    if (minutes % 60 === 0) {
      return useHourFormat ? `${hours}시간` : `${hours}시`;
    } else if (minutes > 60) {
      return useHourFormat ? `${hours}시간 ${mins}분` : `${hours}시 ${mins}분`;
    }

    return useHourFormat ? `${minutes}분` : `${hours}시 ${mins}분`;
  },
};

export default SleepUtils;
